// Generated by ReScript, PLEASE EDIT WITH CARE
'use strict';

var List = require("rescript/lib/js/list.js");
var $$Array = require("rescript/lib/js/array.js");
var Curry = require("rescript/lib/js/curry.js");
var React = require("react");
var Js_dict = require("rescript/lib/js/js_dict.js");
var Belt_Int = require("rescript/lib/js/belt_Int.js");
var Caml_int32 = require("rescript/lib/js/caml_int32.js");
var Js_promise = require("rescript/lib/js/js_promise.js");
var Belt_Option = require("rescript/lib/js/belt_Option.js");
var Json_decode = require("@glennsl/bs-json/src/Json_decode.res.js");
var Querystringify = require("querystringify");
var JsxRuntime = require("react/jsx-runtime");
var RescriptReactRouter = require("@rescript/react/src/RescriptReactRouter.res.js");
var Http$ReactHooksTemplate = require("../common/http.res.js");
var LlmModel$ReactHooksTemplate = require("./llmModel.res.js");
var LlmProvider$ReactHooksTemplate = require("./llmProvider.res.js");
var LlmProviderForm$ReactHooksTemplate = require("./LlmProviderForm.res.js");

var initialState_selectedProvider = LlmProvider$ReactHooksTemplate.emptyProvider();

var initialState = {
  loading: true,
  providers: /* [] */0,
  formAction: "Create",
  providerModalToggle: false,
  selectedProvider: initialState_selectedProvider,
  outsideClick: true
};

function reducer(state, action) {
  if (typeof action !== "object") {
    if (action === "FetchProvidersInProgress") {
      return {
              loading: true,
              providers: state.providers,
              formAction: state.formAction,
              providerModalToggle: state.providerModalToggle,
              selectedProvider: state.selectedProvider,
              outsideClick: state.outsideClick
            };
    } else {
      return {
              loading: state.loading,
              providers: state.providers,
              formAction: state.formAction,
              providerModalToggle: !state.providerModalToggle,
              selectedProvider: state.selectedProvider,
              outsideClick: state.outsideClick
            };
    }
  }
  switch (action.TAG) {
    case "FetchProvidersCompleted" :
        return {
                loading: false,
                providers: action._0,
                formAction: state.formAction,
                providerModalToggle: state.providerModalToggle,
                selectedProvider: state.selectedProvider,
                outsideClick: state.outsideClick
              };
    case "SetFormAction" :
        return {
                loading: state.loading,
                providers: state.providers,
                formAction: action._0,
                providerModalToggle: state.providerModalToggle,
                selectedProvider: state.selectedProvider,
                outsideClick: state.outsideClick
              };
    case "SetProvider" :
        return {
                loading: state.loading,
                providers: state.providers,
                formAction: state.formAction,
                providerModalToggle: state.providerModalToggle,
                selectedProvider: action._0,
                outsideClick: state.outsideClick
              };
    case "SetOutsideClick" :
        return {
                loading: state.loading,
                providers: state.providers,
                formAction: state.formAction,
                providerModalToggle: state.providerModalToggle,
                selectedProvider: state.selectedProvider,
                outsideClick: action._0
              };
    
  }
}

var emptyPageInfo = {
  total: "1",
  per_page: "1"
};

function totalPages(total_records, per_page) {
  return Caml_int32.div(total_records - 1 | 0, per_page) + 1 | 0;
}

function LlmProviders(props) {
  var match = React.useReducer(reducer, initialState);
  var dispatch = match[1];
  var state = match[0];
  var match$1 = React.useState(function (param) {
        return emptyPageInfo;
      });
  var setPageInfo = match$1[1];
  React.useState(function (param) {
        
      });
  var queryParams = Querystringify.parse(props.search);
  var x = Js_dict.get(queryParams, "page");
  var currentPage;
  if (x !== undefined && x !== "") {
    var v = Belt_Int.fromString(x);
    currentPage = v !== undefined ? v : 1;
  } else {
    currentPage = 1;
  }
  var x$1 = Js_dict.get(queryParams, "search");
  var currentSearchKey = x$1 !== undefined && x$1 !== "" ? x$1 : undefined;
  React.useEffect((function (param) {
          var pageNumber = String(currentPage);
          var url = currentSearchKey !== undefined ? "/api/v1/llm_providers?page=" + pageNumber + "&search=" + currentSearchKey : "/api/v1/llm_providers?page=" + pageNumber;
          Curry._1(dispatch, "FetchProvidersInProgress");
          Js_promise.then_((function (param) {
                  var headers = param[0];
                  Curry._1(setPageInfo, (function (param) {
                          var x = headers.get("Total");
                          var total = x !== null ? x : "1";
                          var x$1 = headers.get("Per-Page");
                          var per_page = x$1 !== null ? x$1 : "1";
                          return {
                                  total: total,
                                  per_page: per_page
                                };
                        }));
                  return Js_promise.then_((function (json) {
                                var providers;
                                try {
                                  providers = Json_decode.field("data", (function (param) {
                                          return Json_decode.list(LlmProvider$ReactHooksTemplate.fromJson, param);
                                        }), json);
                                }
                                catch (_err){
                                  console.error("Failed to decode providers");
                                  providers = /* [] */0;
                                }
                                Curry._1(dispatch, {
                                      TAG: "FetchProvidersCompleted",
                                      _0: providers
                                    });
                                return Promise.resolve();
                              }), param[1]);
                }), Http$ReactHooksTemplate.fetchGetJSONWithHeader(url));
        }), [
        currentPage,
        currentSearchKey
      ]);
  var onFormSubmit = function (provider, formAction) {
    var providerId = LlmProvider$ReactHooksTemplate.id(provider);
    var params = {};
    params["llm_provider"] = LlmProvider$ReactHooksTemplate.toJson(provider);
    var submitPromise;
    switch (formAction) {
      case "Create" :
          console.log("create");
          submitPromise = Http$ReactHooksTemplate.fetchPostJSON("/api/v1/llm_providers", params);
          break;
      case "Update" :
          submitPromise = Http$ReactHooksTemplate.fetchPostJSON("/api/v1/llm_providers/" + String(Belt_Option.getExn(providerId)) + "/update", params);
          break;
      case "Delete" :
          console.log("delete");
          submitPromise = Http$ReactHooksTemplate.fetchPostJSON("/api/v1/llm_providers/" + String(Belt_Option.getExn(providerId)) + "/delete", {});
          break;
      
    }
    Js_promise.then_((function (response) {
            var status = Json_decode.field("status", (function (param) {
                    return Json_decode.withDefault("failed", Json_decode.string, param);
                  }), response);
            if (status === "success") {
              window.location.reload();
            }
            return Promise.resolve();
          }), submitPromise);
  };
  var blurBackground = state.providerModalToggle ? "opacity-25" : "opacity-100";
  return JsxRuntime.jsx("div", {
              children: state.loading ? JsxRuntime.jsx("div", {
                      children: "Loading AI Providers...",
                      className: "flex items-center justify-center py-20 text-gray-600 text-lg font-medium"
                    }) : JsxRuntime.jsxs("div", {
                      children: [
                        JsxRuntime.jsx("div", {
                              children: JsxRuntime.jsx("div", {
                                    children: JsxRuntime.jsxs("div", {
                                          children: [
                                            JsxRuntime.jsxs("div", {
                                                  children: [
                                                    JsxRuntime.jsx("div", {
                                                          children: JsxRuntime.jsx("span", {
                                                                children: "🤖",
                                                                className: "text-2xl text-indigo-700"
                                                              }),
                                                          className: "flex items-center justify-center w-12 h-12 rounded-2xl bg-indigo-50 shadow"
                                                        }),
                                                    JsxRuntime.jsxs("div", {
                                                          children: [
                                                            JsxRuntime.jsx("h1", {
                                                                  children: "AI Providers",
                                                                  className: "text-2xl font-bold mb-1 text-gray-900 tracking-tight"
                                                                }),
                                                            JsxRuntime.jsx("p", {
                                                                  children: "Manage available AI providers and models",
                                                                  className: "text-sm text-gray-600"
                                                                })
                                                          ]
                                                        })
                                                  ],
                                                  className: "flex items-center space-x-4"
                                                }),
                                            JsxRuntime.jsx("button", {
                                                  children: "+ Add Provider",
                                                  className: "px-4 py-2 bg-indigo-600 text-white rounded-lg hover:bg-indigo-700 transition-all",
                                                  onClick: (function (param) {
                                                      Curry._1(dispatch, {
                                                            TAG: "SetProvider",
                                                            _0: LlmProvider$ReactHooksTemplate.emptyProvider()
                                                          });
                                                      Curry._1(dispatch, {
                                                            TAG: "SetFormAction",
                                                            _0: "Create"
                                                          });
                                                      Curry._1(dispatch, "ToggleProviderModal");
                                                    })
                                                })
                                          ],
                                          className: "flex items-center justify-between"
                                        }),
                                    className: "bg-gradient-to-r from-blue-50 via-indigo-50 to-purple-50 px-6 py-6 border-b border-gray-200"
                                  }),
                              className: "bg-white rounded-xl shadow-lg border border-gray-200 overflow-hidden mb-6 hover:shadow-xl transition-shadow duration-300 " + blurBackground
                            }),
                        JsxRuntime.jsx("div", {
                              children: JsxRuntime.jsx("div", {
                                    children: JsxRuntime.jsxs("table", {
                                          children: [
                                            JsxRuntime.jsx("thead", {
                                                  children: JsxRuntime.jsxs("tr", {
                                                        children: [
                                                          JsxRuntime.jsx("th", {
                                                                children: "Name",
                                                                className: "py-3 px-6 text-left font-semibold"
                                                              }),
                                                          JsxRuntime.jsx("th", {
                                                                children: "Auth Type",
                                                                className: "py-3 px-6 text-left font-semibold"
                                                              }),
                                                          JsxRuntime.jsx("th", {
                                                                children: "Endpoint",
                                                                className: "py-3 px-6 text-left font-semibold"
                                                              }),
                                                          JsxRuntime.jsx("th", {
                                                                children: "Models",
                                                                className: "py-3 px-6 text-left font-semibold"
                                                              }),
                                                          JsxRuntime.jsx("th", {
                                                                children: "Actions",
                                                                className: "py-3 px-6 text-right font-semibold"
                                                              })
                                                        ]
                                                      }),
                                                  className: "bg-gray-100 text-gray-700 text-xs uppercase tracking-wide border-b border-gray-200"
                                                }),
                                            JsxRuntime.jsx("tbody", {
                                                  children: $$Array.of_list(List.map((function (provider) {
                                                              var id = LlmProvider$ReactHooksTemplate.id(provider);
                                                              return JsxRuntime.jsxs("tr", {
                                                                          children: [
                                                                            JsxRuntime.jsx("td", {
                                                                                  children: LlmProvider$ReactHooksTemplate.name(provider),
                                                                                  className: "py-4 px-6 font-medium text-gray-900"
                                                                                }),
                                                                            JsxRuntime.jsx("td", {
                                                                                  children: LlmProvider$ReactHooksTemplate.authType(provider),
                                                                                  className: "py-4 px-6 text-gray-600 capitalize"
                                                                                }),
                                                                            JsxRuntime.jsx("td", {
                                                                                  children: LlmProvider$ReactHooksTemplate.endpoint(provider),
                                                                                  className: "py-4 px-6 text-gray-600 max-w-xs truncate"
                                                                                }),
                                                                            JsxRuntime.jsx("td", {
                                                                                  children: JsxRuntime.jsx("ul", {
                                                                                        children: $$Array.of_list(List.map((function (model) {
                                                                                                    var id = LlmModel$ReactHooksTemplate.id(model);
                                                                                                    return JsxRuntime.jsxs("li", {
                                                                                                                children: [
                                                                                                                  JsxRuntime.jsx("span", {
                                                                                                                        children: LlmModel$ReactHooksTemplate.name(model),
                                                                                                                        className: "truncate"
                                                                                                                      }),
                                                                                                                  LlmModel$ReactHooksTemplate.active(model) ? JsxRuntime.jsx("span", {
                                                                                                                          children: "✅ Enabled",
                                                                                                                          className: "flex items-center text-green-600 text-xs font-medium"
                                                                                                                        }) : JsxRuntime.jsx("span", {
                                                                                                                          children: "Not Enabled",
                                                                                                                          className: "text-gray-400 text-xs"
                                                                                                                        })
                                                                                                                ],
                                                                                                                className: "flex items-center gap-2"
                                                                                                              }, id !== undefined ? String(id) : LlmModel$ReactHooksTemplate.name(model));
                                                                                                  }), LlmProvider$ReactHooksTemplate.models(provider))),
                                                                                        className: "space-y-1"
                                                                                      }),
                                                                                  className: "py-4 px-6"
                                                                                }),
                                                                            JsxRuntime.jsx("td", {
                                                                                  children: JsxRuntime.jsxs("div", {
                                                                                        children: [
                                                                                          JsxRuntime.jsx("button", {
                                                                                                children: "Edit",
                                                                                                className: "px-3 py-1.5 bg-blue-50 text-blue-700 text-sm font-medium rounded-md hover:bg-blue-100 transition-all",
                                                                                                onClick: (function (param) {
                                                                                                    Curry._1(dispatch, {
                                                                                                          TAG: "SetFormAction",
                                                                                                          _0: "Update"
                                                                                                        });
                                                                                                    Curry._1(dispatch, {
                                                                                                          TAG: "SetProvider",
                                                                                                          _0: provider
                                                                                                        });
                                                                                                    Curry._1(dispatch, "ToggleProviderModal");
                                                                                                  })
                                                                                              }),
                                                                                          JsxRuntime.jsx("button", {
                                                                                                children: "Delete",
                                                                                                className: "px-3 py-1.5 bg-red-50 text-red-700 text-sm font-medium rounded-md hover:bg-red-100 transition-all",
                                                                                                onClick: (function (param) {
                                                                                                    Curry._1(dispatch, {
                                                                                                          TAG: "SetProvider",
                                                                                                          _0: provider
                                                                                                        });
                                                                                                    onFormSubmit(provider, "Delete");
                                                                                                  })
                                                                                              })
                                                                                        ],
                                                                                        className: "flex justify-end gap-2"
                                                                                      }),
                                                                                  className: "py-4 px-6 text-right whitespace-nowrap"
                                                                                })
                                                                          ],
                                                                          className: "hover:bg-indigo-50 transition-colors duration-200"
                                                                        }, id !== undefined ? String(id) : "");
                                                            }), state.providers)),
                                                  className: "divide-y divide-gray-100"
                                                })
                                          ],
                                          className: "min-w-full text-sm text-gray-800"
                                        }),
                                    className: "overflow-x-auto"
                                  }),
                              className: "bg-white rounded-2xl shadow-md border border-gray-100 overflow-hidden transition-all hover:shadow-lg " + blurBackground
                            }),
                        state.providerModalToggle ? JsxRuntime.jsx(LlmProviderForm$ReactHooksTemplate.make, {
                                selectedProvider: state.selectedProvider,
                                onFormSubmit: (function (provider) {
                                    onFormSubmit(provider, state.formAction);
                                  }),
                                toggleModal: (function (param) {
                                    Curry._1(dispatch, "ToggleProviderModal");
                                  })
                              }) : JsxRuntime.jsx(JsxRuntime.Fragment, {})
                      ],
                      className: "max-w-7xl mx-auto space-y-8"
                    }),
              className: "min-h-screen bg-gradient-to-br from-gray-50 to-gray-100 py-10 px-4 sm:px-8"
            });
}

var make = LlmProviders;

exports.initialState = initialState;
exports.reducer = reducer;
exports.emptyPageInfo = emptyPageInfo;
exports.totalPages = totalPages;
exports.make = make;
/* initialState Not a pure module */
